export enum RoleRelativeToOtherSeller {
    JSTIssuer = 'JSTIssuer',
	InvoiceIssuer = 'InvoiceIssuer'
}
